import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/app/timetable/speakerList.scss");
;
import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/app/timetable/timeslot.scss");
;
import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/assets/images/placeholder.png");
